import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';
import { EntityName } from 'services/entities/types';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectOrchard } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

interface ConnectedProps {
    orchard: EntityName;
}

type Props = OwnProps & ConnectedProps;

export class OrchardTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { orchard } = this.props;

        return <TableCell>{orchard}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    orchard: makeSelectOrchard()
});

export default connect(mapStateToProps)(OrchardTableCellComponent);
